import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import DashboardWrapper from '../Dashboard/components/DashboardWrapper'
import InnerBanner from '../../components/InnerBanner'
import { PRIVATE_ROUTES } from '../../Routes/routes'
import InvoiceTable from '../Accounting/components/InvoiceTable'
import { getCompanyInvoices } from '../../services/NewServicesCompnay'
import { isInvoicePaid, mapInvoiceFromApi } from '../../utils/invoiceStatus'

const StatChip = ({ label, value, accent }) => (
  <div
    className="rounded px-3 py-2 d-flex flex-column gap-1"
    style={{
      background: accent ? '#f5f3ff' : '#f9fafb',
      border: `1px solid ${accent ? '#ddd6fe' : '#e5e7eb'}`,
      minWidth: '120px',
    }}
  >
    <span style={{ fontSize: '11px', color: '#6b7280', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
      {label}
    </span>
    <span style={{ fontSize: '20px', fontWeight: '800', color: accent ? '#7c3aed' : '#111827' }}>
      {value}
    </span>
  </div>
)

const CompanyBilling = () => {
  const navigate = useNavigate()
  const [invoices, setInvoices] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const handleRowClick = (invoice) => {
    if (!invoice?.id) return
    navigate(PRIVATE_ROUTES.company_billing_detail.replace(':id', invoice.id))
  }

  const pendingCount = invoices.filter((i) => !isInvoicePaid(i)).length
  const paidCount = invoices.filter((i) => isInvoicePaid(i)).length

  useEffect(() => {
    const fetchInvoices = async () => {
      setIsLoading(true)

      const { response, res } = await getCompanyInvoices(0) || {}
      if (!response?.ok || !Array.isArray(res?.list)) {
        setInvoices([])
        setIsLoading(false)
        return
      }

      setInvoices(res.list.map(mapInvoiceFromApi))
      setIsLoading(false)
    }

    fetchInvoices()
  }, [])

  return (
    <DashboardWrapper>
      <div className="p-3 p-lg-4" style={{ maxWidth: '1100px', margin: '0 auto' }}>

        <InnerBanner
          before="Inicio"
          beforeRoute={PRIVATE_ROUTES.dashboard}
          text="Mis facturas"
          className="mb-3"
        />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
          <h2 className="text-bg-brand mb-0" style={{ fontWeight: 800, fontSize: '22px' }}>
            Historial de facturas
          </h2>

          <div className="d-flex gap-2 flex-wrap">
            <StatChip label="Total"      value={invoices.length} />
            <StatChip label="Pendientes" value={pendingCount} accent={pendingCount > 0} />
            <StatChip label="Pagadas"    value={paidCount} />
          </div>
        </div>

        <div className="bg-white rounded border p-4" style={{ borderColor: '#e5e7eb' }}>
          <InvoiceTable invoices={invoices} isLoading={isLoading} onRowClick={handleRowClick} />
        </div>

      </div>
    </DashboardWrapper>
  )
}

export default CompanyBilling
